const Getters = {
  getShipListFromState: (state) => {
    return state.shipList
  },
  getShipDeliveryListFromState: (state) => {
    return state.shipDeliveryList
  }
}

export default Getters
